module.exports = __webpack_public_path__ + "static/media/test.46706952.svg";